import { EventParams } from '../analytics/interfaces';

type DataTuple<T> = T extends undefined ? [] : [T];

enum Message {
	Log = 'log-message',
	WidgetStateRequest = 'widget-state-request',
	WidgetDirectMessage = 'widget-direct-message'
}

enum DirectMessage {
	OpenURL = 'open-url'
}

interface WidgetDirectMessage {
	name: string;
	params: any;
}

function createMessage<Data = undefined>(type: Message, dataKey: string = 'data') {
	return (...data: DataTuple<Data>) => {
		try {
			const message: Record<any, any> = {
				messageType: type
			};

			if (data.length) {
				message[dataKey] = Object.assign({}, data[0]);
			}

			window.parent.postMessage(JSON.stringify(message), '*');

			if (process.env.NODE_ENV === 'development') {
				console.log(`%c message %c ${type}`, 'background: green', 'background: orange; color: black', message);
			}
		} catch (ex) {
			console.log(ex);
		}
	};
}

const widgetDirectMessage = createMessage<WidgetDirectMessage>(Message.WidgetDirectMessage);

function createDirectMessage<Data = undefined>(type: DirectMessage) {
	return (...data: DataTuple<Data>) => widgetDirectMessage({ name: type, params: data[0] });
}

export const log = createMessage<EventParams>(Message.Log, 'log');
export const widgetStateRequest = createMessage(Message.WidgetStateRequest);
export const openURL = createDirectMessage<string>(DirectMessage.OpenURL);
